module.exports = __webpack_public_path__ + "static/media/admin-app.ad7d68ca.png";